import React, { useState, useRef, useEffect, Suspense } from 'react';
import { TbArrowBadgeDown } from 'react-icons/tb';
import { SlArrowRight } from 'react-icons/sl';
import { Box, Grid, Flex, Image } from '@chakra-ui/react';

const Controls = ({
  isClaim,
  setIsMovingLeft,
  setIsMovingRight,
  setModelPositionX,
  setRoadPositionX,
  setRoadRotateZ,
  setRotateModelScale,
  setSpeed,
  setModelPositionY,
  setModelScale,
  setModel3dX,
  setRotateRoadScale,
  setMovingBoxesOpacity,
  setPagePlay,
  setSessionTokens,
  isMovingLeft,
  isMovingRight,
  models,
  activeModel,
  isAccelerating
}) => {

  const moveLeft = () => {
    setModelPositionX((prev) => Math.max(prev - 30, -40));
    setRoadPositionX((prev) => Math.min(prev + 0.1, 0));
    setRoadRotateZ((prev) => Math.max(prev - 0.3, -5));
    setRotateModelScale((prev) => Math.max(prev - 0.113, -1.18));
  };

  const moveRight = () => {
    setModelPositionX((prev) => Math.min(prev + 30, 40)); 
    setRoadPositionX((prev) => Math.max(prev - 0.1, -2));
    setRoadRotateZ((prev) => Math.min(prev + 0.3, 5));
    setRotateModelScale((prev) => Math.min(prev + 0.11, 1.1));
  };

  const increaseSpeed = () => {
    setSpeed(1.5); 
    setModelPositionY(-60); 
    setModelScale((models[activeModel].scale / 1.171).toFixed(4));
    setModel3dX(-50);
    setRotateRoadScale(5);
    setMovingBoxesOpacity(1);
  };

  const resetSpeed = () => {
    setSpeed(4); 
    setModelPositionY(-30); 
    setModelScale(models[activeModel].scale);
    setModel3dX(-20);
    setRotateRoadScale(8);
    setMovingBoxesOpacity(0);
  };

  useEffect(() => {
    setPagePlay(true);
    setSessionTokens(0);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'a' || e.key === 'A' || e.key === 'ф'  || e.key === 'Ф') { setIsMovingLeft(true); }
      if (e.key === 'd' || e.key === 'D' || e.key === 'в'  || e.key === 'В') { setIsMovingRight(true); }
      //if (e.key === 'w' || e.key === 'W' || e.key === 'ц'  || e.key === 'Ц') { setIsAccelerating(true); } 
    };

    const handleKeyUp = (e) => {
      if (e.key === 'a' || e.key === 'A' || e.key === 'ф'  || e.key === 'Ф') { setIsMovingLeft(false); }
      if (e.key === 'd' || e.key === 'D' || e.key === 'в'  || e.key === 'В') { setIsMovingRight(false); }
      //if (e.key === 'w' || e.key === 'W' || e.key === 'ц'  || e.key === 'Ц') { setIsAccelerating(false); }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, []);

  useEffect(() => {
    let interval;
    if (isMovingLeft) {
      interval = setInterval(moveLeft, 8);
    }
    return () => clearInterval(interval);
  }, [isMovingLeft]);

  useEffect(() => {
    let interval;
    if (isMovingRight) {
      interval = setInterval(moveRight, 8); 
    }
    return () => clearInterval(interval);
  }, [isMovingRight]);

  useEffect(() => {
    let interval;
    if (isAccelerating) {
      increaseSpeed();
    } else {
      resetSpeed();
    }
    return () => clearInterval(interval);
  }, [isAccelerating, models, activeModel]);

  return (
    <Flex 
        w="100%"
        justifyContent="space-between" 
        position="absolute" 
        bottom="40%" 
        zIndex="999" 
        alignItems="center" 
        className={ isClaim ? 'hidden' : '' }
        overflow="visible">
        <Box
          className="lrBtn"
          overflow="visible"
          onMouseDown={() => setIsMovingLeft(true)}
          onMouseUp={() => setIsMovingLeft(false)}
          onMouseLeave={() => setIsMovingLeft(false)}
          onTouchStart={() => setIsMovingLeft(true)}
          onTouchEnd={() => setIsMovingLeft(false)}>
          <SlArrowRight style={{transform: 'rotate(180deg)'}} fontSize="50px"/>
        </Box>
        <Box
          className="rgBtn" 
          overflow="visible"
          onMouseDown={() => setIsMovingRight(true)}
          onMouseUp={() => setIsMovingRight(false)}
          onMouseLeave={() => setIsMovingRight(false)}
          onTouchStart={() => setIsMovingRight(true)}
          onTouchEnd={() => setIsMovingRight(false)}>
          <SlArrowRight style={{transform: 'rotate(0deg)'}} fontSize="50px"/>
        </Box>
    </Flex>
  );
};

export default Controls;
